import { Link } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { Button } from "@ndd/ui";

/*
 * The router-aware half of the not-published state: the surfaces that do have
 * something to show for an RD the latest publication does not cover. It lives
 * apart from `metrics-not-published.tsx` so that panel stays renderable without
 * a router under `tsx --test`; both the RD Snapshot and the Metrics page pass
 * this in as the panel's `actions`.
 */
export function MetricsNotPublishedActions({ rdId }: { rdId: string }): ReactElement {
  return (
    <>
      <Button asChild variant="outline" size="sm">
        <Link to="/rds/$rdId/scorecards" params={{ rdId }}>
          View scorecards
        </Link>
      </Button>
      <Button asChild variant="outline" size="sm">
        <Link to="/rds/$rdId/meetings" params={{ rdId }}>
          View meetings
        </Link>
      </Button>
    </>
  );
}
